/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'link-target': {
    width: 13,
    height: 13,
    viewBox: '0 0 13 13',
    data: '<path pid="0" d="M6.744 1.846a.44.44 0 010 .88h0-3.84c-.565 0-1.025.458-1.025 1.025h0v6.344c0 .566.46 1.026 1.026 1.026h6.344a1.026 1.026 0 001.026-1.026h0V6.256a.44.44 0 01.879 0h0v3.84A1.905 1.905 0 019.249 12h0-6.344A1.905 1.905 0 011 10.095h0V3.751c0-1.052.853-1.905 1.905-1.905h0zM11.776 1l.042.028h.028a.43.43 0 01.112.113h0v.028l.028.042v.085A.436.436 0 0112 1.38h0v3.054a.421.421 0 01-.42.422.42.42 0 01-.42-.422h0v-2.04l-5.258 5.29a.417.417 0 01-.548-.038.424.424 0 01-.04-.552h0l5.259-5.25H8.545a.421.421 0 01-.42-.422c0-.233.189-.422.42-.422h3.231z" _fill="#BEC7D4" _stroke="#BEC7D4" fill-rule="evenodd"/>'
  }
})
